<mat-form-field
  appearance="fill"
  floatLabel="always"
  subscriptSizing="dynamic"
  [ngClass]="{
    'rkt-FormField--full-width': isFullWidth
  }"
  >
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    type="text"
    [attr.autocomplete]="autocomplete"
    [attr.data-testid]="dataTestId"
    [attr.inputmode]="inputmode"
    [attr.maxlength]="maxLength"
    [formControl]="formControlRef"
    [mask]="mask"
    [placeholder]="placeholder"
    />
    @if (!!tooltipText) {
      <mat-icon
        matSuffix
        #tooltip="matTooltip"
        tabindex="0"
        svgIcon="help-default"
        aria-hidden="false"
        (click)="tooltip.toggle()"
        (keypress)="tooltip.toggle()"
        [attr.aria-label]="tooltipText"
        matTooltip="{{ tooltipText }}"
        matTooltipClass="rkt-Tooltip rkt-Tooltip--in-input"
        class="rkt-TooltipPopper"
      ></mat-icon>
    }
    <mat-error [attr.data-testid]="dataTestId + '-error'">{{ errorMessage }}</mat-error>
  </mat-form-field>
